/*

  ______  _____   ______ _______  ______
 |_____/ |     | |  ____ |______ |_____/
 |    \_ |_____| |_____| |______ |    \_

 vehicle sales system

(c) 2006 - 2019 TCE <TCE-ITDevelopers@toyota-ce.com>

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/

(function () {
    "use strict";

    angular
        .module("ROGER")

        //
        .controller("ModelETABrowserController", [
            "$scope", "$http", "$sessionStorage", "$uibModal", "$user", "$oidc",
            function ($scope, $http, $sessionStorage, $uibModal, user, oidc) {

                $scope.$storage = $sessionStorage;
                $scope.user = user;

                // Model browser
                $scope.brand = null;
                $scope.brands = null;
                $scope.model = null;
                $scope.models = null;
                $scope.modelType = null;
                $scope.modelTypes = null;
                $scope.modelGrade = null;
                $scope.modelGrades = null;
                $scope.modelColor = null;
                $scope.modelColors = null;

                $scope.list = [];

                // Load data
                $scope.loadData = function () {
                    $scope
                        .loadBrands(
                            $scope.$storage.catalog.brandId,
                            $scope.$storage.catalog.modelId,
                            $scope.$storage.catalog.modelTypeId,
                            $scope.$storage.catalog.modelGradeId,
                            $scope.$storage.catalog.modelColorId
                        );
                };

                $scope.loadBrands = function (brandId, modelId, modelTypeId, modelGradeId, modelColorId) {
                    $http
                        .get("/api/model-eta-catalog/brand", {
                            params: {
                                retailerId: $scope.$storage.retailer.Id
                            },
                            headers: {
                                Authorization: oidc.current.token_type + " " + oidc.current.access_token
                            }
                        })
                        .then(function (response) {
                            $scope.brands = response.data;
                            $scope.brand = brandId !== null ? $scope.brands.filter(function (item) { return item.Id === brandId; })[0] : $scope.brands[0];

                            if ($scope.brand === null) {
                                $scope.brand = $scope.brands[0];
                            }

                            $scope.loadModels(modelId, modelTypeId, modelGradeId, modelColorId);
                        });
                };

                $scope.loadModels = function (modelId, modelTypeId, modelGradeId, modelColorId) {
                    $http
                        .get("/api/model-eta-catalog/model", {
                            params: {
                                retailerId: $scope.$storage.retailer.Id,
                                brandId: $scope.brand.Id
                            },
                            headers: {
                                Authorization: oidc.current.token_type + " " + oidc.current.access_token
                            }
                        })
                        .then(function (response) {
                            $scope.models = response.data;
                            $scope.model = modelId !== null ? $scope.models.filter(function (item) { return item.Id === modelId; })[0] : $scope.models[0];

                            if ($scope.model === null) {
                                $scope.model = $scope.models[0];
                            }

                            $scope.loadModelTypes(modelTypeId, modelGradeId, modelColorId);
                        });
                };

                $scope.loadModelTypes = function (modelTypeId, modelGradeId, modelColorId) {
                    $http
                        .get("/api/model-eta-catalog/model-type", {
                            params: {
                                modelId: $scope.model.Id,
                                countryId: $scope.$storage.retailer.CountryId
                            },
                            headers: {
                                Authorization: oidc.current.token_type + " " + oidc.current.access_token
                            }
                        })
                        .then(function (response) {
                            $scope.modelTypes = response.data;
                            $scope.modelType = modelTypeId !== null ? $scope.modelTypes.filter(function (item) { return item.Id === modelTypeId; })[0] : null;

                            $scope.loadModelGrades(modelGradeId, modelColorId);
                        });
                };

                $scope.loadModelGrades = function (modelGradeId, modelColorId) {
                    if ($scope.modelType) {
                        $http
                            .get("/api/model-eta-catalog/model-grade", {
                                params: {
                                    modelTypeId: $scope.modelType.Id,
                                    countryId: $scope.$storage.retailer.CountryId
                                },
                                headers: {
                                    Authorization: oidc.current.token_type + " " + oidc.current.access_token
                                }
                            })
                            .then(function (response) {
                                $scope.modelGrades = response.data;
                                $scope.modelGrade = modelGradeId !== null ? $scope.modelGrades.filter(function (item) { return item.Id === modelGradeId; })[0] : null;

                                $scope.loadModelColors(modelColorId);
                            });
                    } else {
                        $scope.modelGrade = null;
                        $scope.modelGrades = [];

                        $scope.loadModelColors(modelColorId);
                    }
                };

                $scope.loadModelColors = function (modelColorId) {
                    $http
                        .get("/api/model-eta-catalog/model-color", {
                            params: {
                                brandId: $scope.brand ? $scope.brand.Id : "",
                                modelGenerationId: $scope.model ? $scope.model.Id : "",
                                modelTypeId: $scope.modelType ? $scope.modelType.Id : "",
                                modelGradeId: $scope.modelGrade ? $scope.modelGrade.Id : "",
                                countryId: $scope.$storage.retailer.CountryId
                            },
                            headers: {
                                Authorization: oidc.current.token_type + " " + oidc.current.access_token
                            }
                        })
                        .then(function (response) {
                            $scope.modelColors = response.data;
                            $scope.modelColor = modelColorId !== null ? $scope.modelColors.filter(function (item) { return item.Id === modelColorId; })[0] : null;

                            $scope.browse();
                        });
                };

                $scope.isFreeCarsOnly = function () {
                    var result = true;
                    if ($scope.$storage.modelETABrowser.switchFreeOrderedReserved === true) {
                        result = false;
                    }
                    return result;
                };

                $scope.browse = function () {
                    $http
                        .get("/api/model-eta-catalog/browse", {
                            params: {
                                retailerId: $scope.$storage.retailer.Id,
                                brandId: $scope.brand.Id,
                                modelId: $scope.model.Id,
                                modelTypeId: $scope.modelType ? $scope.modelType.Id : "",
                                modelGradeId: $scope.modelGrade ? $scope.modelGrade.Id : "",
                                exteriorColorId: $scope.modelColor ? $scope.modelColor.ExteriorColorId : "",
                                countryId: $scope.$storage.retailer.CountryId,
                                freeCarsOnly: $scope.isFreeCarsOnly()
                            },
                            headers: {
                                Authorization: oidc.current.token_type + " " + oidc.current.access_token
                            }
                        })
                        .then(function (response) {
                            $scope.list = response.data;
                        });
                };

                $scope.$watch("$storage.retailer", function (newValue, oldValue) {
                    if (newValue.Id !== oldValue.Id && newValue.Id > 0) {
                        $scope.loadData();
                    }
                });

                $scope.onBrandChanged = function () {
                    $scope.$storage.catalog.brandId = $scope.brand ? $scope.brand.Id : null;

                    $scope.loadModels(null, null, null, $scope.modelColor ? $scope.modelColor.Id : null);
                };

                $scope.onModelChanged = function () {
                    $scope.$storage.catalog.modelId = $scope.model ? $scope.model.Id : null;

                    $scope.loadModelTypes(null, null, $scope.modelColor ? $scope.modelColor.Id : null);
                };

                $scope.onModelTypeChanged = function () {
                    $scope.$storage.catalog.modelTypeId = $scope.modelType ? $scope.modelType.Id : null;

                    $scope.loadModelGrades(null, $scope.modelColor ? $scope.modelColor.Id : null);
                };

                $scope.onModelGradeChanged = function () {
                    $scope.$storage.catalog.modelGradeId = $scope.modelGrade ? $scope.modelGrade.Id : null;

                    $scope.loadModelColors($scope.modelColor ? $scope.modelColor.Id : null);
                };

                $scope.onModelColorChanged = function () {
                    $scope.$storage.catalog.modelColorId = $scope.modelColor ? $scope.modelColor.Id : null;

                    $scope.browse();
                };

                $scope.onFreeOrderedReservedChanged = function () {
                    $scope.browse();
                };

                // Sorting
                $scope.sorting = function (orderName) {
                    if ($scope.$storage.modelETABrowser.orderName === orderName) {
                        $scope.$storage.modelETABrowser.orderDesc = !$scope.$storage.modelETABrowser.orderDesc;
                    } else {
                        $scope.$storage.modelETABrowser.orderName = orderName;
                        $scope.$storage.modelETABrowser.orderDesc = false;
                    }
                };

                $scope.sortingClass = function (orderName) {
                    if ($scope.$storage.modelETABrowser.orderName === orderName) {
                        if ($scope.$storage.modelETABrowser.orderDesc) {
                            return "fa fa-caret-down";
                        } else {
                            return "fa fa-caret-up";
                        }
                    } else {
                        return "";
                    }
                };

                // Queue detail
                $scope.showQueueDetail = function (item) {
                    $uibModal.open({
                        template: require("./ModelQueueDetail.html"),
                        controller: "ModelQueueDetailController",
                        resolve: {
                            model: function () {
                                return item;
                            }
                        }
                    }).result
                        .then(function () {
                            $scope.browse();

                        }, function () {
                            $scope.browse();
                        });
                };

                // Show price view
                $scope.showPricesPreviewReport = function (item) {
                    $http
                        .get("/api/catalog/model-prices", {
                            params: {
                                retailerId: $scope.$storage.retailer.Id,
                                modelColorId: item.ModelColorId
                            },
                            headers: {
                                Authorization: oidc.current.token_type + " " + oidc.current.access_token
                            }
                        })
                        .then(function (response) {
                            $uibModal.open({
                                template: require("./ModelPricesPreview.html"),
                                controller: "ModelPricesPreviewController",
                                resolve: {
                                    modelPriceGroups: function () {
                                        return response.data;
                                    },
                                    model: function () {
                                        return item;
                                    }
                                },
                                size: "lg"
                            }).result
                                .then(function () { }, function () { });
                        });
                };

                // Add to reservations
                $scope.addToReservations = function (item) {
                    $uibModal.open({
                        template: require("./ModelAddToReservations.html"),
                        controller: "ModelAddToReservationsController",
                        resolve: {
                            model: function () {
                                return item;
                            }
                        }
                    }).result
                        .then(function () {

                        }, function () {
                        });
                };

                // Add to order
                $scope.addToOrder = function (item) {
                    $uibModal.open({
                        template: require("./ModelAddToOrder.html"),
                        controller: "ModelAddToOrderController",
                        resolve: {
                            model: function () {
                                return item;
                            }
                        }
                    }).result
                        .then(function () { }, function () { });
                };

                // Find best ETA
                $scope.findBestETA = function (item) {
                    $http
                        .get("/api/catalog/find-best-eta", {
                            params: {
                                retailerId: $scope.$storage.retailer.Id,
                                modelColorId: item.ModelColorId
                            },
                            headers: {
                                Authorization: oidc.current.token_type + " " + oidc.current.access_token
                            }
                        })
                        .then(function (response) {
                            var bestEtaCar = response.data;
                            if (bestEtaCar !== null) {
                                $uibModal.open({
                                    template: require("../Show/ShowBestETA.html"),
                                    controller: "ShowBestETAController",
                                    resolve: {
                                        bestEtaCar: function () {
                                            return bestEtaCar;
                                        }
                                    }
                                }).result
                                    .then(function () { }, function () { });
                            }
                        });
                };

                if ($scope.$storage.retailer !== null && $scope.$storage.retailer.Id > 0) {
                    $scope.loadData();
                }
            }
        ]);
})();